import { apiClient } from '@features/shared/api/client'
import type { SidebarRecentResponse } from './contracts'

const RECENT_PATH = '/users/me/sidebar/recent'

/** GET /users/me/sidebar/recent: the places the user opened lately, newest first. */
export async function getRecentPages(): Promise<SidebarRecentResponse> {
  const { data } = await apiClient.get<SidebarRecentResponse>(RECENT_PATH)
  return data
}

/** PUT /users/me/sidebar/recent: puts a place just opened first. */
export async function recordRecentVisit(path: string): Promise<SidebarRecentResponse> {
  const { data } = await apiClient.put<SidebarRecentResponse>(RECENT_PATH, { path })
  return data
}
